var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 9.33489C7.10538 9.78281 7.70608 10.0352 8.33317 10.0352C8.96026 10.0352 9.56096 9.78281 9.99984 9.33489L12.6665 6.66822C13.587 5.74775 13.587 4.25536 12.6665 3.33489C11.746 2.41441 10.2536 2.41441 9.33317 3.33489L8.99984 3.66822",
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33342 6.66518C8.89455 6.21726 8.29385 5.96484 7.66676 5.96484C7.03966 5.96484 6.43896 6.21726 6.00009 6.66518L3.33342 9.33185C2.41295 10.2523 2.41295 11.7447 3.33342 12.6652C4.2539 13.5857 5.74628 13.5857 6.66676 12.6652L7.00009 12.3319",
    stroke: "#00B3B5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6975231a48b742a05f717df3cfa8abd0.svg";
export { ForwardRef as ReactComponent };